import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useIdentificationsListFetch = (id: string) => {
  const response = useQuery({
    queryKey: ['identificationsList', id],
    queryFn: () => api.identifications.fetchList(id),
  })

  if (response.isError) {
    toaster.create({
      title: 'Не удалось получить список идентификаций',
      description: response.error?.message,
      type: 'error',
    })
  }

  return response
}
